import React, {Component} from 'react';
import {Card} from "semantic-ui-react";
import {connect} from "react-redux";
import ServiceCard from "../components/cleanableCards/serviceCard";
import {getSelectedProperties} from "../utils/common";
import DirtyOnlySwitch from "../components/dirtyOnlySwitch";
import {cardTypes} from "../components/cleanableCards/types";

const mapStateToProps = (state, ownProps) => {
    const {properties} = state;
    const {propertyList, selectedPropertyIds} = properties;
    const selectedProperties = getSelectedProperties(propertyList, selectedPropertyIds);

    return {
        ...ownProps,
        loadingRoomsData: !!properties.loading,
        selectedProperties,
    }
};

class ServiceCleanings extends Component {
    render() {
        const {selectedProperties} = this.props;

        return (
            <div>
                <DirtyOnlySwitch  typeName={cardTypes.SERVICE_CLEANINGS}/>

                <Card.Group>
                    {selectedProperties.map(sp => {
                        const propertyName = sp.propertyName;
                        const propertyId = sp.id;

                        if (!!sp && !!sp.checkoutCleanings) {
                            return sp.serviceCleanings.map((c, idx) =>
                                <ServiceCard key={idx}
                                             {...c}
                                             propertyName={propertyName}
                                             propertyId={propertyId}
                                />)
                        }

                        return null;
                    })}
                </Card.Group>
            </div>
        );
    }
}

export default connect(mapStateToProps)(ServiceCleanings);
